import React, { useState } from "react";
import { Link } from "react-router-dom";
import { createPageUrl } from "@/utils";
import { User } from "@/entities/User";
import { useUser } from "@/lib/useUser";
import { logger } from "@/lib/logger";
import { AlertTriangle, X } from "lucide-react";

export default function AlphaBanner() {
  const { user, refetchUser } = useUser();
  const [dismissing, setDismissing] = useState(false);
  const [locallyDismissed, setLocallyDismissed] = useState(false);

  if (!user) return null;
  if (user.beta_banner_dismissed === true) return null;
  if (locallyDismissed) return null;

  const handleDismiss = async () => {
    if (dismissing) return;
    setDismissing(true);
    setLocallyDismissed(true);
    try {
      await User.updateMyUserData({ beta_banner_dismissed: true });
      await refetchUser();
    } catch (err) {
      logger.error(err, { context: "AlphaBanner dismiss" });
      setLocallyDismissed(false);
    } finally {
      setDismissing(false);
    }
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-40 w-full bg-amber-500/10 border-b border-amber-500/30 text-amber-100"
    >
      <div className="flex items-center gap-3 px-4 py-2 text-sm">
        <AlertTriangle className="w-4 h-4 flex-shrink-0 text-amber-300" aria-hidden="true" />
        <p className="flex-1 min-w-0 truncate">
          <span className="font-medium">NimbleNode is in alpha — you're one of a handful of testers.</span>{" "}
          <span className="text-amber-100/80">
            Hit a bug, found something confusing, or have an idea?
          </span>{" "}
          <Link
            to={createPageUrl("Feedback")}
            className="underline underline-offset-2 font-medium text-amber-200 hover:text-white"
          >
            Send feedback &rarr;
          </Link>
        </p>
        <button
          type="button"
          onClick={handleDismiss}
          disabled={dismissing}
          aria-label="Dismiss alpha banner"
          className="flex-shrink-0 p-1 rounded hover:bg-amber-500/20 text-amber-200 hover:text-white transition-colors disabled:opacity-50"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}